import DocumentWrapper from "./DocumentWrapper";

export default DocumentWrapper;



// WEBPACK FOOTER //
// ./src/components/DocumentWrapper/index.js